// extracted by mini-css-extract-plugin
export default {"metaInfo":"StyleAssetThumb_metaInfo__NGWL5","open":"StyleAssetThumb_open__UqE3I"};